import { RowDescriptor } from '../Card';

export const trackingCardId = 'tracking-card-navigation-id';

export const trackingRowDescriptor: RowDescriptor[] = [];
